import React from 'react'
import withProps from 'recompose/withProps'
import styled from 'react-emotion'
import Link from 'gatsby-link'
import { mediumMediaQuery } from 'utils/style-helpers'
import instagramIcon from './instagram.svg'
import twitterIcon from './twitter.svg'

const List = styled.ul`
  display: flex;
  margin: 0 15px 20px;

  li {
    display: inline-block;
    width: 48px;
    height: 48px;
    margin: 0 24px 0 0;

    &:last-child {
      margin-right: 0;
    }
  }

  ${mediumMediaQuery} {
    margin: 0;
  }
`

const MediaLink = withProps({
  target: '_blank'
})(styled.a`
  display: block;
  height: 100%;
  font-size: 0;
`)

const Instagram = withProps({
  href: 'https://instagram.com/_chouxbox/'
})(styled(MediaLink)`
  background: url(${instagramIcon}) no-repeat;
`)

const Twitter = withProps({
  href: 'https://twitter.com/_ChouxBox'
})(styled(MediaLink)`
  background: url(${twitterIcon}) no-repeat;
`)

const SocialMedia = () => (
  <List>
    <li><Instagram>Instagram</Instagram></li>
    <li><Twitter>Twitter</Twitter></li>
  </List>
)

export default SocialMedia



// WEBPACK FOOTER //
// ./src/components/Footer/SocialMedia/index.js